import { takeEvery } from 'redux-saga/effects';
import { GlobalAction, GlobalActions, LogError } from '@ps20-frontend/shop-integration-redux';
import { PS20Logger } from '@ps20-frontend/logging';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';

export function* watchLogError() {
  yield takeEvery(GlobalActions.LOG_ERROR, safeSaga(logError, App.SHOP));
}

export function logError(action: GlobalAction<LogError>): void {
  const { appId, errorOrExceptionText, message } = action.payload;
  PS20Logger.error(appId, errorOrExceptionText, message);
}
